import $ from '@sparta.global.vendors/jquery';
import spartaValidationFramework from '@sparta.global.utilities/sparta-validation-framework-utility/dist/es6.js';
import spartaMaskingUtility from '@sparta.global.utilities/sparta-masking-utility/dist/es6.js';
import CommonUtility from '@sparta.sales.utilities/common-utility/dist/es6.js';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';

class InputUtility {
  clear($input) {
    if (this.isSelectInput($input)) {
      $input.find('option[value!=""]').remove();
    } else if (this.isRadioInput($input) || this.isCheckboxInput($input)) {
      $input.prop('checked', false);
    } else {
      $input.val('');
    }
  }
  disable($input) {
    $input.prop('disabled', true);
    $input.attr('aria-disabled', 'true');
    return $input;
  }
  enable($input) {
    $input.prop('disabled', false);
    $input.attr('aria-disabled', 'false');
    return $input;
  }
  require($input) {
    const astrisk_txt = '<span class="spa-input-label--required"> *</span><span class="ada-hidden"></span>';
    const $ada_txt = $input.parent().find('.ada-hidden');
    const $label = $input.parent().find('label');
    const not_required_str = '(not required)';
    const has_notrequired_txt = $label.text().indexOf(not_required_str) > -1;
    if ($ada_txt.parent().text().indexOf('*') === -1) $ada_txt.replaceWith(astrisk_txt);
    if (has_notrequired_txt) $label.text($label.text().replace(not_required_str, ''));
    $input.prop('required', true);
    $input.attr('aria-required', 'true');
    return $input;
  }
  unRequire($input) {
    const $astrisk = $input.parent().find('.spa-input-label--required');
    $astrisk.remove();
    $input.prop('required', false);
    $input.attr('aria-required', 'false');
    return $input;
  }
  convertSelectToTextInput($select) {
    let $new_input;
    const input_value = $select.find('option:selected').text();
    $select.find('option').remove();
    $select.parent().removeClass('spa-dropdown');
    $select.removeAttr('onchange data-val').attr('type', 'text');
    $select.removeClass('spa-input-select').addClass('spa-input-text');
    $new_input = $($select[0].outerHTML.replace('select', 'input').replace('</select>', ''));
    $new_input.val(input_value.trim());
    $select.replaceWith($new_input);
    return $select; // really an input now
  }

  convertTextInputToText($input, classes_str = '', attrs = '') {
    const val = $input.val();
    const id = $input.attr('id');
    $input = $input.replaceWith(`<p id="${id}" class="${classes_str}" ${attrs}>${val}</p>`);
    return $input; // really now just plain ol text node
  }

  isSelectInput($input) {
    return $input[0].type && $input.prop('type').includes('select') || false;
  }
  isRadioInput($input) {
    return $input[0].type && $input.prop('type') === 'radio' || false;
  }
  isCheckboxInput($input) {
    return $input[0].type && $input.prop('type') === 'checkbox' || false;
  }
  isTextInput($input) {
    return $input[0].type && $input.prop('type') === 'text' || $input.prop('type') === 'tel' || false;
  }

  // the value can be manually passed if you want to by passing it as a string
  selectSelectValue($input, value) {
    if (typeof value !== 'string') {
      value = this.getValueFromDataStructure($input, value);
    }
    $input.find(`option[value="${value}"]`).prop('selected', true).change();
  }
  selectRadioValue($input, value) {
    if (typeof value !== 'string') {
      value = this.getValueFromDataStructure($input, value);
    }
    if (`${$input.data('value')}` === value) $input.prop('checked', true).change();
  }
  insertTextInputValue($input, value) {
    if (typeof value !== 'string') {
      value = this.getValueFromDataStructure($input, value);
    }
    $input.val(value);
  }
  insertTextValue($input, value) {
    if (typeof value !== 'string') {
      value = this.getValueFromDataStructure($input, value, '-text');
    }
    $input.text(value);
  }
  hideHintText($input) {
    $input.parent().find('.spa-input-hint').hide();
    return $input;
  }
  showHintText($input) {
    $input.parent().find('.spa-input-hint').show();
    return $input;
  }
  getValueFromDataStructure($input, data, type = '') {
    const data_structure = $input.data(`structure${type}`);
    let value = data_structure.split('.').reduce((key, val) => key[val], data);
    value = value === null ? '' : value;
    return data_structure ? `${value}` : '';
  }

  // Create object with value array (value) and data array (key) for fillInDropdownValues method to handle
  createOptionMarkupDataObject(inValue) {
    const option_data = {
      value_arr: [],
      data_arr: []
    };
    if (inValue instanceof Array) {
      if (inValue.length > 0) {
        if (inValue[0] instanceof Array) {
          inValue.forEach(ins => {
            option_data.value_arr.push(ins[1]);
            option_data.data_arr.push(ins[0]);
          });
        } else {
          inValue.forEach(v => {
            if (v.value && v.text) {
              option_data.value_arr.push(v.text);
              option_data.data_arr.push(v.value);
            } else {
              Object.keys(v).forEach(key => {
                option_data.value_arr.push(v[key]);
                option_data.data_arr.push(key);
              });
            }
          });
        }
      }
    } else {
      Object.keys(inValue).forEach(key => {
        option_data.value_arr.push(inValue[key]);
        option_data.data_arr.push(key);
      });
    }
    return option_data;
  }
  fillInDropdownValues($input, values = false, run_multiple = false, useKeyAsValue = false) {
    /**
     * Condition 1: you've provided a values {} that has a key called 'value_arr' and another called 'data_arr' for
     * corresponding values and data
     * */
    if (values && values.data_arr) {
      const option_values = values.value_arr;
      const option_data = values.data_arr;
      option_values.forEach((value, i) => {
        option_data.forEach((datum, j) => {
          if (i === j) {
            // If useKeyAsValue is true, use the data_arr key values as the inputs value.
            // Useful for country dropdowns which need to pass country codes
            if (useKeyAsValue) {
              $input.append($(`<option data-optiondata='${datum}'/>`).val(datum).text(value));
            } else {
              $input.append($(`<option data-optiondata='${datum}'/>`).val(value).text(value));
            }
          }
        });
      });
      /**
       * Condition 2: your values are a simple {} of keys and vals or...
       * */
    } else if (values && $input.find('option').length <= 1 || run_multiple) {
      // the length assumes you have an empty dropdown val
      /**
       * Condition 3: you've been provided a json obj and each object has a key called 'value' and one called 'text'
       * for the corresponding value and text of the option we're making
       * */
      if (values.constructor === Array && values[0].hasOwnProperty('text') && values[0].hasOwnProperty('value')) {
        values = values.map(obj => ({
          [obj.text]: obj.value
        }));
      } else {
        /** Condition 4: you've been provided a plain object but we are going to turn it into json so we can do
         *  the next part regardless of the myriad of forms of data the backend likes to provide
         */
        values = Object.keys(values).map(k => ({
          [values[k]]: k
        }));
      }
      /**
       * put the keys and vals in the options as values and text, respectively
       * */
      values.map(obj => {
        $input.append($('<option/>').val(Object.values(obj)[0]).html(Object.keys(obj)[0]));
      });
    }
    return $input;
  }
  applySpartaInputValidation($module) {
    $module.spartaInputs();
    const input_validations = {};
    $module.find('[data-validation-rules]').map((i, obj) => {
      const $el = $(obj);
      input_validations[$el.attr('id')] = $el.data('validation-rules');
    });
    spartaValidationFramework.fn.core.bindValidationRules(input_validations, true);
  }
  regexHelperCurrency(inputString) {
    // allow 7 digits before decimal, decimal, and 2 digits after decimal
    const regExAllowed = String.raw`^\d{0,7}(\.\d{1,2})?$`;

    // const regExRestrictions = String.raw ``
    const passesAllowed = !!inputString.match(regExAllowed);
    return passesAllowed;
  }

  // Allows alphanumeric only plus the following special characters: apostrophe, dash, period, spaces, and forward slash.
  // Does not allow only spaces or only special characters.
  // Returns true if string passes the above requirements
  regexHelperAlphaNumSpecialCharForwardSlash(inputString) {
    const regExAllowed = String.raw`^[\w'./-\s]+$`;
    const regExRestrictions = String.raw`\d|[a-zA-Z]`;
    const passesAllowed = !!inputString.match(regExAllowed);
    const passesRestrictions = !!inputString.match(regExRestrictions);
    return !!(passesAllowed && passesRestrictions);
  }

  // Allows alphanumeric only plus the following special characters: apostrophe, dash, period, and spaces.
  // Does not allow only spaces or only special characters.
  // Returns true if string passes the above requirements
  regexHelperAlphaNumSpecialChar(inputString) {
    const regExAllowed = String.raw`^[\w'.-\s]+$`;
    const regExRestrictions = String.raw`\d|[a-zA-Z]`;
    const passesAllowed = !!inputString.match(regExAllowed);
    const passesRestrictions = !!inputString.match(regExRestrictions);
    return !!(passesAllowed && passesRestrictions);
  }

  // Allows alphanumeric only plus the following special characters: apostrophe,double quotation, dash, period, and spaces.
  // Does not allow only spaces or only special characters.
  // Returns true if string passes the above requirements
  regexHelperAlphaNumSpecialCharQuotation(inputString) {
    const regExAllowed = String.raw`^[\w'".-\s]+$`;
    const regExRestrictions = String.raw`\d|[a-zA-Z]`;
    const passesAllowed = !!inputString.match(regExAllowed);
    const passesRestrictions = !!inputString.match(regExRestrictions);
    return !!(passesAllowed && passesRestrictions);
  }

  // Allows alphanumeric only plus the following special characters: apostrophe,double quotation,slash, dash, period, and spaces.
  // Does not allow only spaces or only special characters.
  // Returns true if string passes the above requirements
  regexHelperAlphaNumSpecialCharQuotationwithSlash(inputString) {
    const regExAllowed = String.raw`^[\w'/".-\s]+$`;
    const regExRestrictions = String.raw`\d|[a-zA-Z]`;
    const passesAllowed = !!inputString.match(regExAllowed);
    const passesRestrictions = !!inputString.match(regExRestrictions);
    return !!(passesAllowed && passesRestrictions);
  }

  // Allows alpha only plus the following special characters: apostrophe, dash, period, and spaces.
  // Does not allow only spaces or only special characters.
  // Returns true if string passes the above requirements
  regexHelperAlphaSpecialChar(inputString) {
    const regExAllowed = String.raw`^[a-zA-Z'.-\s]+$`;
    const regExRestrictions = String.raw`[a-zA-Z]`;
    const passesAllowed = !!inputString.match(regExAllowed);
    const passesRestrictions = !!inputString.match(regExRestrictions);
    return !!(passesAllowed && passesRestrictions);
  }

  // Allows alphanumeric only plus the following special characters: apostrophe, dash, period, and spaces, comma slash pound  .
  // if allowExtraSpecialCharacters is true then allow  = - ,  / # . apostrophe
  // Must start with a digit.
  // Does not allow only spaces or only special characters.
  // Returns true if string passes the above requirements
  regexHelperAddressNumber(inputString, allowExtraSpecialCharacters) {
    const regExAllowed = allowExtraSpecialCharacters ? String.raw`^\d[\w'#\-,\/.-\s]*$` : String.raw`^\d[\w'.-\s]*$`;
    const regExRestrictions = String.raw`\d|[a-zA-Z]`;
    const passesAllowed = !!inputString.match(regExAllowed);
    const passesRestrictions = !!inputString.match(regExRestrictions);
    return !!(passesAllowed && passesRestrictions);
  }

  // Returns false if string contains any form of P.O. Box (regardless of case, spaces or periods)
  regexHelperPoBox(inputString) {
    // force lowercase, remove spaces, remove periods ".", check if "pobox" occurs anywhere in the string
    return !(inputString.toLowerCase().split('.').join('').replace(/ /g, '').indexOf('pobox') > -1);
  }
  bindDateFormatting($dateInput) {
    const allowedKeys = ['Tab', 'Backspace', 'ArrowLeft', 'ArrowRight'];

    // This is to catch when a key is pressed while the field has focus.
    $dateInput.on('keypress', e => {
      const keyValue = e.key || String.fromCharCode(e.keyCode);
      if (allowedKeys.includes(keyValue)) {
        return true;
      }
      if (!keyValue.match(/[\d\/]/)) {
        e.preventDefault();
        return false;
      }
      const input = e.currentTarget;
      const startPosition = input.selectionStart;
      const endPosition = input.selectionEnd;

      // If the phone number field is complete and nothing is selected, get out of here.
      if (input.value.length === 10 && startPosition === endPosition) {
        e.preventDefault();
        return;
      }

      // If the cursor is where the dashes should be, insert the dash, then the number, and update the position of the cursor.
      if (startPosition === 2 || startPosition === 5) {
        if (keyValue !== '/') {
          input.value = `${input.value.substring(0, startPosition)}/${input.value.substring(endPosition, input.value.length)}`;
          input.setSelectionRange(startPosition + 1, startPosition + 1);
        }
      } else if (keyValue === '/') {
        // if we are not at a place that needs a dash and one was typed, then reject it.
        e.preventDefault();
        return;
      }

      // if the phone number position is the number before one of the dashes and there's at least ten characters already,
      // prevent the browser from inserting the number and inject it in the right place with the dash and set the cursor
      // position after the dash. Without this you could end up with 5555-5555 or 55-555555 and have to hit a number
      // or dash to force the dash to be added. This assures it's added automatically.
      if ((startPosition === 1 || startPosition === 4) && input.value.length >= 8) {
        e.preventDefault();
        const dashes = input.value.match(/\//g);
        const dashCount = dashes ? dashes.length : 0;
        if (dashCount > 1) {
          input.value = input.value.substring(0, startPosition) + keyValue + input.value.substring(endPosition, input.value.length);
        } else {
          input.value = `${input.value.substring(0, startPosition) + keyValue}/${input.value.substring(endPosition, input.value.length)}`;
        }
        input.setSelectionRange(startPosition + 2, startPosition + 2);
      }
    })

    // This catches when the field gets a value pasted into it. Formatting is applied to the whole number.
    .bind('paste', e => {
      e.preventDefault();
      const clipboardData = e.clipboardData || e.originalEvent.clipboardData || window.clipboardData;
      let inputVal = clipboardData.getData('text');
      inputVal = inputVal.replace(/[^*\d\/]/g, '');
      if (inputVal.length > 9 && inputVal.match(/\//) == null) {
        const firstTen = inputVal.substring(0, 10);
        inputVal = firstTen.replace(/^([*\d]{3})([*\d]{3})([\d]{4})+$/, '$1/$2/$3');
        if (e.type === 'input') {
          $(input).change();
        }
      }
      $dateInput.val(inputVal);
      spartaValidationFramework.fn.core.validateAllFieldRules($dateInput);
    });
  }

  /**
   * @method
   * @name bindInputMasking
   * @desc Intercepts the sparta masking event (blur.gisMasking) and rebinds it handling asterisks.
   * @param $input
   * Used for prefill functionality only
   */
  bindInputMasking($input, type, $dfrd = false) {
    if (!type.match(/^(email)?(phone)?(ssn)?$/)) {
      console.error(`bindInputMasking: Unsupported masking type '${type}' for input ID ${$input.attr('id')}.`);
      return;
    }
    const $inputMask = $(`#${$input.attr('id')}-masked`);

    // Here's where we get tricky and unbind the default sparta mask binding and rebind it with our own function that does handle asterisks.
    $input.unbind('blur.gisMasking').on('blur.gisMasking', event => {
      // Set the value of the phoneChangeMask field to the masked value that the sparta masking utility gives us.
      $inputMask.val(spartaMaskingUtility.fn.maskingRules[type]($input.val().replace(/\*/g, '9')));
      // This timeout is is to recreate the same delay that the sparta masking utility uses. Since we intercepted the event,
      // we also have to intercept this responsibility.
      setTimeout(() => {
        // Here we hide the phoneChange field and show the phoneChangeMask field the same way that sparta would.
        if ($input.val() !== '') {
          spartaMaskingUtility.fn.helpers.hideElement($input, true);
          spartaMaskingUtility.fn.helpers.hideElement($inputMask, false);
          if ($dfrd) {
            $dfrd.resolve();
          }
        }
        if ($input.hasClass(' spa-error-form-input--validation')) {
          $inputMask.addClass('spa-error-form-input--validation');
        } else {
          $inputMask.removeClass('spa-error-form-input--validation');
        }
      }, 200);
    });
  }

  // This function accepts a string with a valid email address and returns a string with masked values
  // Used for review and submit pages
  maskEmailAddress(emailAddress) {
    // In the case of a short local address (1 or 2 charachters before the "@" symbol),
    // the characters should be masked.

    // Check if less than 3 characters are present before the @ symbol.
    // Then mask those characters
    if (emailAddress.indexOf('@') === 1 || emailAddress.indexOf('@') === 2) {
      return emailAddress.toString().replace(/.(?=[^@]*@)/g, '\u25CF');
    }
    // Except for the first and last, mask every character before the @ symbol
    return emailAddress.toString().replace(/(?!^).(?=[^@]*.@)/g, '\u25CF');
  }

  /**
   * @method populateInputs
   * @param data
   * @param $scope
   * @param servicePrefill
   * @desc Searching withith the scope (jQuery element) for all populatable inputs and populates them with data
   *        from the passed data object based on the data-structure of the input.
   */
  populateInputs(data, $scope, servicePrefill = false) {
    const $visiblePage = $scope;
    const notouch = servicePrefill ? ', .notouch' : '';
    const getPopulatableInputs = () => $([
    // All of the visible inputs on the page that do not have the classes of .found or .notough
    $visiblePage.find(`input:not('.gis-mask-value, .found ${notouch}'), select:not('.gis-mask-value, .found ${notouch}')`).filter(':visible'),
    // All of the inputs, visible or not, that have the class of .always-prefill. Excluding elements that have the class of .found.
    $visiblePage.find("input.always-prefill:not('.gis-mask-value, .found'), select.always-prefill:not('.gis-mask-value, .found')"),
    // All of the fields that have masking applied which are not hidden. Have to be sure the masked field is visible, then merge them into our group.
    $visiblePage.find(`input.spa-hidden.gis-mask-original:not(.found ${notouch})`).filter((i, v) => $(v).siblings('.gis-mask-value').is(':visible:not(.spa-hidden)'))].reduce(($a, $b) => $.merge($a, $b)));
    const visibleInputs = getPopulatableInputs();

    // Add a class to show that we've already found the inputs that were found.
    // Below we'll run the query again to find any newly visible fields and add
    // them to visibleInputs.
    visibleInputs.addClass('found');

    // Turn the initResponse into a dot notated data object
    const dataObject = CommonUtility.makeDotNotatedDataObject(data);

    // Loop through the list of visible inputs.
    for (let i = 0; i < visibleInputs.length; i++) {
      const dataKey = $(visibleInputs[i]).data('structure');
      const inputType = visibleInputs[i].type;
      const $input = $(visibleInputs[i]);

      // Get out of here if this data structure is configured not to populate.
      if (spaParams.pageParams.nonPopulatingDataStructures) {
        if (spaParams.pageParams.nonPopulatingDataStructures.includes(dataKey)) {
          continue;
        }
      }

      // Do something with this input only if the data object has a key matching it's data-structure
      if (dataObject[dataKey] !== undefined) {
        // If dataObject[dataKey] is nulll, set it to an empty string.
        dataObject[dataKey] = dataObject[dataKey] === null ? '' : dataObject[dataKey];

        // For checkboxes, we simply set it's checked value to it's matching value in the
        // dataObject. The value from the dataObject should always be either true or false.
        if (inputType === 'checkbox') {
          // if the datakey is a empty string, null, or undefined, set it to false. If the datakey is any of these the checkbox is clicked when
          // page loads
          dataObject[dataKey] = dataObject[dataKey] === '' ? false : dataObject[dataKey];
          dataObject[dataKey] = dataObject[dataKey] === null ? false : dataObject[dataKey];
          dataObject[dataKey] = dataObject[dataKey] === undefined ? false : dataObject[dataKey];
          this.triggerFieldEvents($input.attr('checked', dataObject[dataKey]), data);
        }

        // For radio buttons, we check to see if it's value matches the dataObject's value for this key.
        // If it matches, check it, otherwise, remove it's checked attribute altogether.
        else if (inputType === 'radio') {
          if ($input.val() === dataObject[dataKey].toString() || $input.data('value') === dataObject[dataKey]) {
            if (!$input.val()) {
              $input.val($input.data('value'));
            }
            this.triggerFieldEvents($input.prop('checked', 'checked'), data);
          } else {
            $input.prop('checked', false);
          }
        }

        // Text inputs and selects will end up here. We just set their values according to what
        // was found in the dataObject.
        else {
          this.triggerFieldEvents($input.val(dataObject[dataKey]), data);

          // Empty Strings were leaving old values stuck in the mask inputs since no masking takes place
          // when the original input is empty.
          if (!!$input.siblings('[data-sparta-input-mask]').length && dataObject[dataKey] === '') {
            $input.siblings('[data-sparta-input-mask]').val(dataObject[dataKey]);
          }
        }
      }

      // We'll only check for new visible inputs at the end of the loop to speed things up.
      if (i === visibleInputs.length - 1) {
        // Since triggering the change event on some inputs may make other variable inputs visible,
        // we now need to add any newly visible inputs that do not have the .found class already.
        // Since the outer loop here is counting indexes, adding new inputs to visibleInputs will
        // just extend the loop; making sure that every input that becomes visible will get prefilled
        // if there is data available matching its data structure.
        visibleInputs.push(...getPopulatableInputs());
        visibleInputs.addClass('found');
      }
    }

    // Now that we are done, we don't need the .found class anymore. Clean up.
    visibleInputs.removeClass('found');

    // Publish and event to tell the other modules that prefilling is complete.
    if (servicePrefill) {
      setTimeout(() => {
        spartaEventsUtility.pub('SERVICE_PREFILL-COMPLETE');
      }, 51);
    }
  }

  /**
   * Triggers the change and blur events on a passed field.
   * Also, any specific actions that need to be taken to fill out a form correctly should be accounted for here.
   * @param $field
   */
  triggerFieldEvents($field, data) {
    // Yes, this looks crazy. Mardochee and I (Micah), looked into why it takes two change triggers
    // to make some events actually happen... no luck. If you have the time, feel free to look into it.
    // The purpose of this is to trigger the showing of inputs that show when certain inputs have certain values.
    // The blur triggers the masking to happen.
    if ($field.val() != null) {
      $field.change().change().blur();
    }

    // Trigger click for radios.
    if ($field.prop('type') === 'radio') {
      $field.click().blur();
    }

    // Here we publish an event to let the modules know to run any events needed during field population.
    spartaEventsUtility.pub(`PREFILL_EVENT_TRIGGER-${$field.attr('id')}`, data);
  }
}
var index = new InputUtility();

export { index as default };
